<script setup lang="ts">
import type { RouteLocationRaw } from '#vue-router'

const props = defineProps<{
  title: stringI18n
  sup?: string | number
  line?: boolean
  fs?: 'm_fs1'
  to?: RouteLocationRaw | None
}>()
</script>

<template>
  <div class="_row _ctry _c1 _wm100p _hidden _hm28">
    <span v-if="$slots.default" class="_ctr _mr1 _relative"><slot /></span>
    <LinkFalling v-if="to" :to class="_upper" :class="fs" :txt="title" />
    <span v-else class="_upper" :class="fs">{{ title }}</span>
    <sup v-if="helpers.isDef(sup)" :class="$style.sup">{{ sup }}</sup>
    <div v-if="line" :class="$style.after" />
  </div>
</template>

<style module>
.sup {
  composes: global(_row);
  composes: global(_fs07);
  composes: global(_fw-xl);
  composes: global(_pt04);
  composes: global(_pl04);
  composes: global(_pr04);
  composes: global(_pb04);

  composes: global(_c1);
  align-self: flex-start;
}
.after {
  height: 1px;
  composes: global(_flex);
  composes: global(_bg5);
  composes: global(_br9);
  composes: global(_ml14);
  composes: global(_noselect);
}
</style>
